// biome-ignore lint/performance/noBarrelFile: intentional
export {
  type ToSignatureErrorType as ToEventSignatureErrorType,
  toSignature as toEventSignature,
} from './toSignature.js'
